<script setup lang="ts">
import HelpDeskTicketLogs from "@/domains/home/services/configurations/views/helpdesk/HelpDeskTicketLogs.vue";
</script>

<template>
  <HelpDeskTicketLogs />
</template>
